import React from 'react'
import Header from '../Components/Header'
import PageLayout from '../Layouts/PageLayout'
import RichText from '../Components/RichText'
import { useLanguage } from '../i18n/LanguageContext'


export default function TeachersPanel() {
  const { teachers, platform, ui } = useLanguage().content;
  const { principal, instructors } = teachers;
  const t = ui.teachers;

  return (
    <PageLayout 
        header={
            <Header title={t.title}>
                <div className="bg-gradient-to-br from-secondary/20 to-bgMuted rounded-full w-36 h-36 mx-auto my-4 flex items-center justify-center border-4 border-primary/30">
                    <img src="/outline_in_hijab.svg" alt={t.principalAlt} className="w-24 h-24"/>
                </div>
                <h2 className="text-2xl font-serif font-bold text-primary">{principal.name}</h2>
                <p className="text-accent font-medium">{principal.title}</p>
            </Header>
        }
        firstColumn={
            <div className="mt-6 text-lg">
                <h3 className="font-serif font-bold text-xl text-primary mb-4">{t.aboutHeading}</h3>
                <article className="text-justify text-textDark space-y-4 leading-relaxed">
                    {principal.bio.map((paragraph) => {
                        if (paragraph.style === 'highlight') {
                            return (
                                <div key={paragraph.text} className="bg-gradient-to-r from-secondary/20 to-transparent p-4 rounded-lg border-l-4 border-secondary">
                                    <p className="font-medium text-primary"><RichText text={paragraph.text}/></p>
                                </div>
                            );
                        }
                        return (
                            <p key={paragraph.text} className={paragraph.style === 'closing' ? 'italic text-accent' : undefined}>
                                <RichText text={paragraph.text}/>
                            </p>
                        );
                    })}
                </article>
            </div>
        }
    >
        <div className="md:col-span-2 flex flex-col gap-8 text-lg">
            {/* Instructors Section - Two Column Grid */}
            <div className="bg-bgMuted/50 rounded-xl p-6 shadow-sm">
                <h3 className="font-serif font-bold text-2xl text-primary mb-6">{t.instructorsHeading}</h3>
                <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                    {instructors.map((instructor) => (
                        <div key={instructor.name} className="flex items-center gap-3 p-3 bg-white/50 rounded-lg">
                            <span className="w-3 h-3 bg-secondary rounded-full"></span>
                            <div>
                                <div className="font-semibold text-textDark">{instructor.name}</div>
                                <div className="text-sm text-accent">{instructor.subjects}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Platform Specialities - Full Width with Two Columns */}
            <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl p-6 shadow-sm border border-secondary/30">
                <h3 className="font-serif font-bold text-xl text-primary mb-6 text-center">{t.specialitiesHeading}</h3>
                <ul className="grid md:grid-cols-2 grid-cols-1 gap-4 text-textDark">
                    {platform.specialities.map((item) => (
                        <li key={item} className="flex items-start gap-3 bg-white/40 p-3 rounded-lg">
                            <span className="w-2 h-2 bg-primary rounded-full mt-2 shrink-0"></span>
                            <span>{item}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
     </PageLayout>
  )
}
